import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/hooks/useAuth";

/**
 * Unread count from the notifications table (read=false) for the bell badge
 * (G-003). Head-only count.
 *
 * 008: den tidigare realtime-kanalen här är BORTTAGEN. Tabellen `notifications`
 * ligger inte i publikationen `supabase_realtime` (0 rader i
 * pg_publication_tables), så prenumerationen fyrade aldrig — badgen har hela
 * tiden uppdaterats enbart av pollen nedan, medan koden såg ut att vara
 * realtidsdriven. Att i stället publicera tabellen hade broadcastat varje
 * notisrad till alla anslutna klienter; pollen plus den explicita
 * invalideringen i Notifications.tsx täcker behovet.
 */
export function useUnreadNotificationsCount(): number {
  const { user } = useAuth();

  const { data: count = 0 } = useQuery({
    queryKey: ["notifications-unread", user?.id],
    queryFn: async () => {
      const { count, error } = await supabase
        .from("notifications")
        .select("id", { count: "exact", head: true })
        .eq("user_id", user!.id)
        .eq("read", false);
      if (error) return 0;
      return count ?? 0;
    },
    enabled: !!user?.id,
    staleTime: 30_000,
    refetchInterval: 30_000,
  });

  return count;
}
